module.exports = __webpack_public_path__ + "img/IMG_4215_FoamcoreMatted.73e489ed.jpg";